define('adminKitcTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('kitcs.details.tabTitle')
    }, {
      name: 'kitcqct',
      title: _.i18n('kitcs.kitcqct.tabTitle')
    }
  ];
});
